import styled from '@emotion/styled'

import { colors, textEllipsis, typo } from '~/@common/styles'
import { mediaQuery } from '~/@common/styles/mediaQuery'

export const S = {
  Header: styled.section`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    max-width: 1280px;
    height: 80px;
    margin: 0 auto;
    padding: 19px 40px;
    background-color: white;

    .gnb__nav {
      display: flex;
      gap: 10px;
      max-width: 1280px;
      ${mediaQuery.underTablet} {
        width: 100%;
        justify-content: space-between;

        &.gnb__nav-bottom {
          height: 55px;
          padding: 14px 16px;
        }
      }
    }
    .gnb__nav-link {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 8px 12px;
      color: ${colors.gray.$700};
      white-space: nowrap;
      ${typo.body01};

      svg {
        display: none;
      }

      &.active {
        background-color: rgba(57, 95, 226, 0.05);
        border-radius: var(--Radius-200);
        color: ${colors.blue.$500};
        font-weight: 700;
        svg {
          display: block;
        }
      }
    }

    .gnb__nav-logo {
      display: flex;
      align-self: center;
      height: 100%;
      width: 120px;

      .gnb__nav-logo-image {
        max-width: 100%;
        object-fit: contain;
      }

      ${mediaQuery.underTablet} {
        align-items: center;
        width: 96px;
      }
    }

    .gnb__nav-link-mobile {
      display: flex;
      align-items: center;
      gap: 20px;
      font-weight: 700;
      color: ${colors.gray.$700};
      .title-container {
        display: flex;
        flex-direction: column;
        position: relative;
      }
      &.active {
        color: ${colors.blue.$500};
      }
      .underline {
        position: absolute;
        width: 100%;
        height: 2px;
        background-color: ${colors.blue.$500};
        bottom: -4px;
      }

      &.gnb__child-switch-mobile {
        color: var(--Colors-Gray-700);
        gap: 0;
        flex-shrink: 0;
      }
    }
    .gnb__userService {
      display: flex;
      align-items: center;
      gap: 12px;
      font-weight: 700;
    }
    .gnb__userService-opinion {
      display: flex;
      align-items: center;
      height: 44px;
      gap: 6px;
      border-radius: var(--Radius-200);
      padding: 0 12px;
      border: 1px solid ${colors.gray.$300};
      color: ${colors.gray.$700};
      ${typo.body01}
      white-space: nowrap;

      > svg {
        width: 22px;
        height: 22px;
        color: #d9d9d9;
      }
    }

    .gnb__userService-profile {
      display: flex;
      align-items: center;
      gap: 6px;
      border-radius: var(--Radius-200);
      padding: 0px 12px;
      height: 44px;
      border: 1px solid ${colors.gray.$300};
      color: ${colors.gray.$700};
      ${typo.body01}
      min-width: 130px;
      img {
        height: 22px;
      }
      .name {
        min-width: 78px;
        text-align: right;
        font-weight: 700;
        ${textEllipsis(1)}
      }

      &.active {
        border: 1px solid rgba(57, 95, 226, 0.2);
        background-color: rgba(57, 95, 226, 0.05);
        color: var(--Colors-Blue-500);
      }

      /* 학부모: "내정보"는 짧으므로 min-width 해제 */
      &.gnb__userService-profile--parent {
        min-width: auto;

        .name {
          min-width: auto;
        }
      }
    }
    .gnb__userService-qrCode {
      border-radius: var(--Radius-200);
      padding: 8px;
      border: 1px solid ${colors.gray.$300};
      width: 42px;
      height: 42px;
    }
    .qr__button-guide-wrapper {
      display: flex;
      position: absolute;
      right: 60px;
      top: -7px;
    }
    .qr__button-guide {
      padding: 8px 12px;
      width: 194px;
      border-radius: var(--Radius-200);
      background-color: ${colors.white};
      color: ${colors.gray.$900};
      text-align: right;
      ${typo.body02}
    }
    .qr__button-wrapper {
      position: relative;
    }
    .qr__button {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 42px;
      height: 42px;
      background-color: white;
      border-radius: var(--Radius-200);
      border: 1px solid ${colors.gray.$300};
      padding: 8px;
      z-index: 2;

      ${mediaQuery.underTablet} {
        width: 32px;
        height: 32px;
        padding: 6px;
        > svg {
          width: 100%;
          height: 100%;
        }
      }
    }
    .qr__icon-wrapper {
      position: absolute;
      top: 50%;
      right: 50%;
      transform: translate(50%, -50%);
      display: flex;
      justify-content: center;
      align-items: center;
      width: 70px;
      height: 70px;
      border-radius: var(--Radius-Circle);
      background-color: white;
    }

    ${mediaQuery.underTablet} {
      flex-direction: column;
      justify-content: center;
      border-bottom: 1px solid ${colors.gray.$400};
      padding: 0;
      height: auto;

      .gnb__nav-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 60px;
        padding: 0 16px;
      }

      .gnb__nav-top-right {
        display: flex;
        align-items: center;
        gap: 10px;
      }
    }
  `,
}
